import axios from 'axios';
import Cookies from 'js-cookie';
import {
  getAuthHeader,
  removeCookieSession,
  setCookie
} from './userInfo-actions';
import { userDataActions } from './user-slice';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_COOKIE_CONSTANT}`
);

export const getUserInSession = idEmisor => {
  return async dispatch => {
    let userData = await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/account/homeload`,
      {
        params: {
          idEmisor
        },
        headers: getAuthHeader(jwtCookie)
      }
    );
    if (userData.status === 200) {
      dispatch(
        userDataActions.info({
          userInfo: userData.data
        })
      );
    }
  };
};

export const getValidationName = course => {
  return async dispatch => {
    let validationName = await axios.get(
      `${process.env.REACT_APP_API_PATH_USER}/user/name/valid`,
      {
        params: {
          course
        },
        headers: getAuthHeader(jwtCookie)
      }
    );
    if (validationName.status === 200) {
      dispatch(
        userDataActions.validation({
          validationName:
            validationName.data.validated === 0 ? false : true
        })
      );
    }
  };
};

export const confirmNameValidate = async course => {
  let confirmNameData = await axios.put(
    `${process.env.REACT_APP_API_PATH_USER}/user/name/valid`,
    {
      course
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (confirmNameData.data.updated) {
    return true;
  }
  return false;
};

export const logOut = () => {
  removeCookieSession();
};

export const getUserAccount = async email => {
  const userAccount = await axios.get(
    `${process.env.REACT_APP_API_PATH_MAYAHII_USER_INFO}/auth/user/check`,
    {
      params: {
        email
      }
    }
  );
  if (userAccount.data.userVO) {
    return true;
  }
  return false;
};

export const logIn = async (email, password) => {
  const url = window.location.pathname.split('/');
  let logIn = await axios.post(
    `${process.env.REACT_APP_API_PATH_MAYAHII_USER_INFO}/auth/login`,
    {
      email,
      password
    }
  );
  if (!logIn.data.response) {
    return true;
  } else {
    setCookie(logIn.data.response);
    window.location.href = `/${url[1]}`;
  }
};

export const registerUser = async (
  firstName,
  lastName,
  emailUser,
  passUser,
  lada,
  cellphone,
  languageCode,
  countryCode,
  currencyCode,
  currencySymbol,
  termsLogin
) => {
  const register = await axios.post(
    `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/account`,
    {
      firstName,
      lastName,
      emailUser,
      passUser,
      lada,
      cellphone,
      languageCode,
      countryCode,
      currencyCode,
      currencySymbol,
      termsLogin
    }
  );
  if (register.data.value === false) {
    return false;
  } else {
    return true;
  }
};

export const updateLanguageUser = (userId, language) => {
  return async () => {
    await axios.put(
      `${process.env.REACT_APP_API_PATH_USER}/user/language`,
      {
        userId,
        language
      },
      { headers: getAuthHeader() }
    );
  };
};

export const finishApplication = async (
  emisorId,
  courseId,
  lessonId,
  scormScore,
  scormPassed,
  totalProgress
) => {
  let finishQuiz = await axios.post(
    `${process.env.REACT_APP_API_PATH_SCORM}/scorm/save`,
    {
      emisorId,
      courseId,
      lessonId,
      scormScore,
      scormPassed,
      totalProgress
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (finishQuiz.status === 200) {
    return finishQuiz.data;
  }
  return false;
};
